import { createFileRoute } from "@tanstack/react-router";
import { DashboardsListPage } from "@/features/dashboards/pages";

export const Route = createFileRoute("/_app/dashboards/")({
  head: () => ({ meta: [{ title: "Dashboards · Malfak" }] }),
  component: DashboardsListPage,
});
